import type { DayPickerProps } from 'react-day-picker';
import dayjs from 'dayjs';

export const getInceptionDatePickerProps = (expiryDate?: string | null): DayPickerProps => {
  if (!expiryDate) {
    return {};
  }

  return {
    disabled: { after: dayjs(expiryDate).add(-1, 'day').toDate() },
  };
};

export const getExpiryDatePickerProps = (inceptionDate?: string | null): DayPickerProps => {
  const today = dayjs();

  if (!inceptionDate) {
    return { disabled: { before: today.toDate() } };
  }

  const dayAfterInception = dayjs(inceptionDate).add(1, 'day');
  const floor = dayAfterInception.isAfter(today, 'day') ? dayAfterInception : today;

  return { disabled: { before: floor.toDate() } };
};
